export const blockIconsBusinessandpaymentsWorkHistoryNew = (
	<span className='material-symbols-outlined'>work_history</span>
);
